import {
  GAME_ID,
  ONBOARDING_TOPPER_KEY,
  REDUX_ACTIONS,
} from '../../data/wordCityConstants';

/* Session-only: nothing here is read back from the server, and no middleware persists it. Mastery
does reach the server, but by a separate route — sendGameQuestMetadata -> setQuestStepLevelMastered. */
const initialState = {
  highestLevelEarned: 0,
  gameDetails: {
    // object with toppers earned by user: levelId => topperId
    toppers: {},
    isOnboardingCompleted: false,
  },
  isToppersQuestResetDone: false,
};

const wordCityGameDetailsReducer = (state = initialState, { gameId, type, payload = {} }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.UPDATE_GAME_PRACTICE_DETAILS: {
      const { highestLevelEarned, toppers, isMastered } = payload;

      return {
        ...state,
        highestLevelEarned,
        isMastered,
        gameDetails: {
          ...state.gameDetails,
          toppers,
        },
      };
    }
    case REDUX_ACTIONS.UPDATE_GAME_ONBOARDING_DETAILS: {
      return {
        ...state,
        gameDetails: {
          ...state.gameDetails,
          isOnboardingCompleted: true,
          // left alone when none was chosen: null reads as 0, which crowns a phantom district
          toppers: payload.topperId === null
            ? state.gameDetails.toppers
            : { ...state.gameDetails.toppers, [ONBOARDING_TOPPER_KEY]: payload.topperId },
        },
      };
    }
    case REDUX_ACTIONS.RESET_GAME_TOPPERS_DETAILS_FOR_QUEST: {
      return {
        ...state,
        gameDetails: {
          ...state.gameDetails,
          toppers: {},
        },
        isToppersQuestResetDone: true,
      };
    }
    default:
      return state;
  }
};

export default wordCityGameDetailsReducer;
